export default "__VITE_ASSET__mb2_QuAD__"